import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { NotificationTemplate } from "../index";
import { useRequirementInstructionsModal } from "../../../../Requirements/components/RequirementsDetails/useRequirementInstructionsModal";
import { useGoToDashboardPayerRequirementDetails } from "../../../routes/RouteRequirementDetails/RoutePayerRequirementDetails";

export type FileSharingRequestContractorContext = {
  requirement: {
    requirementId: string;
    name: string;
    dataSourceId: string;
  };
  payer: {
    payerId: string;
    payerName: string;
    logoFileId?: string;
  };
};
const GROUP_THRESHOLD = 2;

export const FileSharingRequestContractor: NotificationTemplate<FileSharingRequestContractorContext> =
  {
    renderTitle: props =>
      props.group.length >= GROUP_THRESHOLD
        ? "Multiple file uploads required"
        : "File upload required",
    renderBody: props => {
      if (props.group.length >= GROUP_THRESHOLD) {
        const payerNames = new Set(
          props.group.map(item => item.context.payer.payerName)
        );
        const payerNamesString = Array.from(payerNames).join(", ");
        return `File uploads requested by ${payerNamesString}`;
      }

      return (
        <>
          <b>{props.context.requirement.name}</b> file upload required requested
          by <b>{props.context.payer.payerName}</b>.
        </>
      );
    },
    Footer: props => {
      const goToPayerRequirementDetails =
        useGoToDashboardPayerRequirementDetails();
      const instructionsRequirementModal = useRequirementInstructionsModal();

      const history = useHistory();

      if (props.group.length >= GROUP_THRESHOLD) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              history.push("/member/dashboard/contractor-files-sharing");
            }}
          >
            View requirements
          </WSButton.Link>
        );
      } else {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onAsyncClick={async () => {
              const instructionsResult =
                await instructionsRequirementModal.open({
                  requirementId: props.context.requirement.requirementId
                });

              if (instructionsResult !== true) return;

              goToPayerRequirementDetails({
                requirementId: props.context.requirement.requirementId,
                payerId: props.context.payer.payerId
              });
            }}
          >
            Complete requirement
          </WSButton.Link>
        );
      }
    }
  };
